"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "aquila-d-arroscia": {
    "59bd655c": [{
      "hkey": "37fc58e5",
      "slug": "aquila-d-arroscia",
      "name": "Aquila d'Arroscia",
      "primary": true,
      "skipSearch": false
    }],
    "affreddore": [{
      "hkey": "37fc58e5",
      "slug": "aquila-d-arroscia",
      "name": "Aquila d'Arroscia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f24e213b": [{
      "hkey": "37fc58e5",
      "slug": "aquila-d-arroscia",
      "name": "Aquila d'Arroscia",
      "primary": true,
      "skipSearch": false
    }],
    "loga": [{
      "hkey": "37fc58e5",
      "slug": "aquila-d-arroscia",
      "name": "Aquila d'Arroscia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d69c37d9": [{
      "hkey": "37fc58e5",
      "slug": "aquila-d-arroscia",
      "name": "Aquila d'Arroscia",
      "primary": true,
      "skipSearch": false
    }],
    "maglioreto": [{
      "hkey": "37fc58e5",
      "slug": "aquila-d-arroscia",
      "name": "Aquila d'Arroscia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "24e190a1": [{
      "hkey": "37fc58e5",
      "slug": "aquila-d-arroscia",
      "name": "Aquila d'Arroscia",
      "primary": true,
      "skipSearch": false
    }],
    "prato": [{
      "hkey": "37fc58e5",
      "slug": "aquila-d-arroscia",
      "name": "Aquila d'Arroscia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;